var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 7.66671C1.33325 8.40311 1.93021 9.00004 2.66659 9.00004C3.77115 9.00004 4.66659 8.10464 4.66659 7.00004V4.33337C4.66659 3.22881 3.77115 2.33337 2.66659 2.33337C1.93021 2.33337 1.33325 2.93033 1.33325 3.66671V7.66671Z",
    stroke: "#2E2C27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3192 10.7958L10.1417 10.2225C9.99622 9.75264 9.92348 9.51771 9.97941 9.33217C10.0247 9.18211 10.124 9.05271 10.2594 8.96757C10.4267 8.86237 10.6799 8.86237 11.1861 8.86237H11.4555C13.1689 8.86237 14.0255 8.86237 14.4302 8.35517C14.4764 8.29724 14.5175 8.23557 14.5531 8.17091C14.8644 7.60531 14.5105 6.84331 13.8027 5.31931C13.1532 3.92078 12.8284 3.22152 12.2254 2.80994C12.1671 2.77009 12.1071 2.73251 12.0456 2.69728C11.4107 2.33337 10.6242 2.33337 9.05101 2.33337H8.70981C6.80388 2.33337 5.85093 2.33337 5.25884 2.90706C4.66675 3.48075 4.66675 4.40409 4.66675 6.25075V6.89984C4.66675 7.87031 4.66675 8.35551 4.83897 8.79964C5.0112 9.24377 5.34098 9.60897 6.00054 10.3393L8.72815 13.3596C8.79655 13.4354 8.83075 13.4733 8.86095 13.4996C9.14241 13.7445 9.57688 13.717 9.82301 13.4385C9.84941 13.4086 9.87821 13.3668 9.93581 13.283C10.0259 13.152 10.071 13.0865 10.1103 13.0216C10.4619 12.4406 10.5683 11.7504 10.4073 11.0953C10.3893 11.0221 10.3659 10.9466 10.3192 10.7958Z",
    stroke: "#2E2C27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs-down.ce03fc901f97577f6ef5c407d00a7fe0.svg";
export { ForwardRef as ReactComponent };